class ArnAnalytics {
  constructor() {
    let bankedGfkMediaId = false;
    let bankedGfkRegionId = false;
    let bankedGfkVisibilityScript = false;
    let bankedGfkIsProduction = false;
    let bankedDataLayer = false;
    if (typeof window.ArnAnalytics !== 'undefined') {
      bankedDataLayer = JSON.parse(
        JSON.stringify(window.ArnAnalytics.dataLayer)
      );
      bankedGfkMediaId = window.ArnAnalytics.gfkMediaId;
      bankedGfkRegionId = window.ArnAnalytics.gfkRegionId;
      bankedGfkVisibilityScript = window.ArnAnalytics.gfkVisibilityScript;
      bankedGfkIsProduction = window.ArnAnalytics.gfkIsProduction;
    }

    window.ArnAnalytics = this;
    window.sessionPingTimeout = false;

    this.nielsenInitialFired = false;
    this.nielsenApid = false;
    this.nielsenSdkInstance = false;
    this.nielsenMetadataObject = {};

    this.gfkMediaId = bankedGfkMediaId;
    this.gfkRegionId = bankedGfkRegionId;
    this.gfkVisibilityScript = bankedGfkVisibilityScript;
    this.gfkIsProduction = bankedGfkIsProduction;
    this.resetDataLayer();
    if (bankedDataLayer) {
      const bankedKeys = Object.keys(bankedDataLayer);
      bankedKeys.forEach(keyName => {
        this.dataLayer[keyName] = bankedDataLayer[keyName];
      });
    }

    this.nielsenInitialPage = this.nielsenInitialPage.bind(this);
    this.nielsenSubsequentPage = this.nielsenSubsequentPage.bind(this);
    this.loadGFKScript = this.loadGFKScript.bind(this);

    this.loadGFKScript();

    this.resetDataLayer = this.resetDataLayer.bind(this);
    this.updateDataLayer = this.updateDataLayer.bind(this);
  }

  resetDataLayer() {
    this.dataLayer = {
      title: '',
      brand: '',
      postSlug: '',
      postUrl: '',
      category: '',
      categories: '',
      authorName: '',
      postType: '',
      publishTime: '',
      articleLength: '',
      sponsor: '',
      tag: '',
      tags: '',
      tone: '',
      tones: '',
      radioShow: '',
      celebrity: '',
      celebrities: '',
      subCategory: '',
      syndicatedFrom: '',
      containsVideo: '',
      usingAdblock: '',
    };
  }

  updateDataLayer(newDataLayer) {
    const bankedKeys = Object.keys(newDataLayer);
    bankedKeys.forEach(keyName => {
      this.dataLayer[keyName] = newDataLayer[keyName];
    });
  }

  // Fires a GA Pageview event and
  /* DIMENSIONS
   * ----------
   * 1 - Category
   * 2 - Subcategory
   * 3 - Post Type
   * 4 - Publish Time
   * 5 - Article Length
   * 6 - Author Name
   * 7 - Radio Show
   * 8 - Celebrity
   * 9 - Tone
   * 10 - Medium
   * 11 - Sponsor
   * 12 - Syndicated From
   * 13 - Contains Video
   * 14 - Using Adblock
   */
  pageviewEvent() {
    if (this.checkIfPageIsExcluded()) return;
    console.log(window.pageviewData);

    gtag('event', 'page_view', {
      'dimension1': window.pageviewData.category,
      'dimension2':window.pageviewData.subCategory,
      'dimension3':window.pageviewData.postType,
      'dimension4':window.pageviewData.publishTime,
      'dimension5':window.pageviewData.articleLength,
      'dimension6':window.pageviewData.authorName,
      'dimension7':window.pageviewData.radioShow,
      'dimension8':window.pageviewData.celebrity,
      'dimension9':window.pageviewData.tone,
      'dimension10':window.pageviewData.medium,
      'dimension11':window.pageviewData.sponsor,
      'dimension12':window.pageviewData.syndicatedFrom,
      'dimension13':window.pageviewData.containsVideo,
      'dimension14':window.pageviewData.usingAdblock
    });


    clearTimeout(this.sessionPingTimeout);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pjaxPageView',
    });
    this.nielsenSubsequentPage();

    this.sendDataToDMP();
  }

  sendDataToDMP() {
    window.arnDil = DIL.create({
      partner: 'arn',
      uuidCookie: {
        name: 'aam_uuid',
        days: 30,
      },
      visitorService: {
        namespace: '625227F95C6A98AA0A495D64@AdobeOrg',
      },
    });

    const siteName = window.siteData.identity;
    const namespace = `c_${siteName}_`;

    window.arnDil.api.signals({ c_purl: document.URL });
    window.arnDil.api.signals({ c_preferer: document.referrer });
    window.arnDil.api
      .signals(window.ArnAnalytics.dataLayer, namespace)
      .submit();
  }

  niesenNSETracking() {
    if (this.checkIfPageIsExcluded()) return;
    if (window.trac) {
      window.trac.pageEvent(window.pageviewData.postSlug);
    }
  }

  checkIfPageIsExcluded() {
    const testUrl = `${window.siteData.siteUrl}/video-embed`;
    const testUrl2 = '/video-embed/';
    if (
      window.location.href.indexOf(testUrl) > -1 ||
      window.location.href.indexOf(testUrl2) > -1
    ) {
      return true;
    }
    return false;
  }

  // Initial Nielsen pageview event
  /* metadataObject must look like:
  ----------------------------------
    var staticMetadataObject = {
        type: "static", //Required: the same for every static asset
        assetid: "id-123456", //Required and needs to be unique per asset
        section: "Example Section Name", //Required: please discuss values with Nielsen
        segA: "Segment A Name", //Optional: optional segment reporting
        segB: "Segment B Name", //Optional: optional segment reporting
        segC: "Segment C Name" //Optional: used for off-platform - FBIA and Google AMP
    };
   */
  nielsenInitialPage(metadataObject) {
    this.nielsenSdkInstance = window.NOLBUNDLE.nlsQ(
      this.nielsenApid,
      'window.ArnAnalytics.nielsenSdkInstance',
      { nol_sdkDebug: 'DEBUG' }
    );

    this.nielsenMetadataObject = JSON.parse(JSON.stringify(metadataObject));
    this.nielsenSdkInstance.ggPM('staticstart', this.nielsenMetadataObject);
    this.nielsenInitialFired = true;
  }

  // Subsequent events need to also close the previous event
  nielsenSubsequentPage() {
    if (!this.nielsenInitialFired) return;
    this.nielsenMetadataObject.referrerURL =
      this.nielsenMetadataObject.pageURL || window.location;
    this.nielsenMetadataObject.pageURL = window.location;
    // this.nielsenMetadataObject.section = currentSection; //optional reporting metadata update
    this.nielsenSdkInstance.ggPM('staticstart', this.nielsenMetadataObject);
  }

  replaceNielsenMetadataObject(nielsenMetadataObject) {
    if (!this.nielsenInitialFired) return;
    this.nielsenSdkInstance.ggPM('staticend', this.nielsenMetadataObject);
    this.nielsenMetadataObject = JSON.parse(
      JSON.stringify(nielsenMetadataObject)
    );
  }

  // GFK Livestream Tracking
  loadGFKScript() {
    if (
      this.gfkMediaId === false ||
      this.gfkMediaId === '' ||
      typeof this.gfkMediaId === 'undefined' ||
      this.gfkRegionId === false ||
      this.gfkRegionId === '' ||
      typeof this.gfkRegionId === 'undefined'
    ) {
      return;
    }

    window.gfkS2s = {};

    // let gfkUrl = `//${this.gfkRegionId}-config-preproduction.sensic.net/s2s-web.js`;
    // if(this.bankedGfkIsProduction === true || this.bankedGfkIsProduction === 'true') {
    //   gfkUrl = `//${this.gfkRegionId}-config.sensic.net/s2s-web.js`;
    // }

    const gfkUrl = `//au-config.sensic.net/s2s-web.js`;

    const gfkS2sConf = {
      media: this.gfkMediaId,
      url: gfkUrl,
      visUrl: this.gfkVisibilityScript,
      type: 'WEB',
      logLevel: 'all',
    };

    (function(w, d, c, s, id, v) {
      if (d.getElementById(id)) {
        return;
      }

      w.gfkS2sConf = c;
      w[id] = {};
      w[id].agents = [];
      const api = [
        'playStreamLive',
        'playLive',
        'playStreamOnDemand',
        'playVOD',
        'stop',
        'skip',
        'screen',
        'volume',
        'impression',
      ];
      let e;
      w.s = (function() {
        function f(sA, e, cb) {
          return function() {
            sA.p = cb();
            sA.queue.push({ f: e, a: arguments });
          };
        }
        function s(c, pId, cb) {
          const sA = { queue: [], config: c, cb, pId };
          for (let i = 0; i < api.length; i++) {
            e = api[i];
            sA[e] = f(sA, e, cb);
          }
          return sA;
        }
        return s;
      })();
      w[id].getAgent = function(cb, pId) {
        const a = {
          a: new w.s(c, pId || '', cb || (() => 0)),
        };
        function g(a, e) {
          return function() {
            return a.a[e].apply(a.a, arguments);
          };
        }
        for (let i = 0; i < api.length; i++) {
          e = api[i];
          a[e] = g(a, e);
        }
        w[id].agents.push(a);
        return a;
      };

      const lJS = function(eId, url) {
        const tag = d.createElement(s);
        const el = d.getElementsByTagName(s)[0];
        tag.id = eId;
        tag.async = true;
        tag.type = 'text/javascript';
        tag.src = url;
        el.parentNode.insertBefore(tag, el);
      };

      if (c.hasOwnProperty(v)) {
        lJS(id + v, c[v]);
      }
      lJS(id, c.url);
    })(window, document, gfkS2sConf, 'script', 'gfkS2s', 'visUrl');
  }

  // Fires a custom GA event
  customEvent(eventData) {
    console.log('Custom Event');
    if (!eventData) return;

    let eventCategory =
      typeof eventData.category !== 'undefined' ? eventData.category : false;
    let eventAction =
      typeof eventData.action !== 'undefined' ? eventData.action : false;
    const eventLabel =
      typeof eventData.label !== 'undefined' ? eventData.label : false;
    const eventValue =
      typeof eventData.value !== 'undefined' ? eventData.value : false;
    const customUrl =
      typeof eventData.customUrl !== 'undefined' ? eventData.customUrl : false;

    if (!eventCategory && !eventAction && !eventLabel) return;
    if (!eventCategory) {
      eventCategory = eventAction !== false ? eventAction : eventLabel;
    }
    if (!eventAction) {
      eventAction = eventCategory !== false ? eventCategory : eventLabel;
    }
    const sendToDmp =
      typeof eventData.sendToDmp !== 'undefined' ? eventData.sendToDmp : false;

    console.log('EVENT DATA VALIDATED');

    const eventDataObject = {
      hitType: 'event',
      eventCategory,
      eventAction,
      eventLabel,
      eventValue,
    };
    if (customUrl) {
      eventDataObject.location = customUrl;
    }

    gtag('event', eventAction, {
        'category': eventCategory
    });


    if (sendToDmp) {
      this.sendDmpEvent(eventData);
    }
  }

  sendDmpEvent(eventData) {
    const siteName = window.siteData.identity;
    const namespace = `c_${siteName}`;
    let signalKey = `${namespace}_${eventData.action.replace(/ /g, '')}`;
    if (eventData.action !== eventData.label) {
      signalKey += `_${eventData.label.replace(/ /g, '')}`;
    }

    if (window.arnDil) {
      window.arnDil.api.signals({ c_purl: document.URL });
      window.arnDil.api.signals({ c_preferer: document.referrer });

      const signal = {};
      signal[signalKey] = true;
      window.arnDil.api.signals(signal);
      window.arnDil.api.signals().submit();
    }
  }

}

export default () => new ArnAnalytics();
